import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Map } from "immutable";
import {
    Row,
    Col,
    Layout,
    Modal,
    Divider,
    Checkbox,
    Input,
    Select,
    Form
} from "antd";
import DocumentViewList from "./document-view-list";
import SignzyDataForm from "./../../forms/signzy-data-form";
import { List } from "immutable";
import { DOCUMENT_CURRENT_STATUS } from "constants/enums";
import {
    uploadDocument,
    uploadDocuments,
    fetchCompanyDocuments,
    updateDocument,
    fetchApplicantsList,
    fetchDocumentTypes,
    invalidateDocument,
    requestDocuments,
    validateDocument,
    attachDocument,
    failedValidateDocument,
    failedInvalidateDocumentStatus,
    parseDocument,
    sendRequest,
    addRequestRemarks,
    fetchCaseDetail,
} from "store/actions";
import { PermissionContextManager } from "hocs/permission-context-manager";
import { UI_PERMISSIONS, STATE_STATUS } from "constants/index";
import "styles/document-review.css";
let scrollPositionValue = 0;
const {TextArea} = Input;
const FormItem = Form.Item;

const applicantDocuments = {
    7 : "Pan Card",
    6 : "Photograph",
    63 : "Aadhar Card M",
};

const otherDocuments = {
    46 : "Others"
}

const applicantAadharBoth = {
    "63-12" : "Aadhar - Front",
    "63-13" : "Aadhar - Back"
}; 

class CompanyDocumentReviewTab extends React.PureComponent {
    state = {
        selectedFilePath: null,
        selectedFileType: null,
        selectedFile: null,
        fileName: null,
        docMaster: new List([]),
        requestedDocs: [],
        showRequestedRemarks: false,
        requestedRemarks: null,
        searchFilterVals: null,
        applicantSelectModal : false,
        requestedApplicantDocs : [],
        document : [],
        filteredAadharBoth : [],
        filterOtherDocuments : []
    };

    async handleFetchDocumentMasterList() {
        if (this.props.docMasterListStatus == STATE_STATUS.UNFETCHED) {
            this.props.fetchDocumentTypes();
        }
    }

    async handleFetchApplicantList() {
        if (this.props.associatesStatus == STATE_STATUS.UNFETCHED) {
            this.props.fetchApplicantsList(this.props.companyId);
        }
    }

    async handleFilesFetch(forceUpdate = false) {
        const t = this;
        if (
            t.props.companyId &&
            (t.props.filesStatus === STATE_STATUS.UNFETCHED || forceUpdate)
        ) {
            t.props.fetchCompanyDocuments(
                '',
                t.props.companyId
            );
        }
    }

    componentDidMount() {
        this.handleFetchDocumentMasterList();
        this.handleFilesFetch();
        this.handleFetchApplicantList();
        this.createRequestDocIdList();
        this.handleScrollPosition();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.docMasterList &&
            (this.props.docMasterList.length ||
                this.props.docMasterList.size) &&
            !this.state.isDocumentFetched
        ) {
            this.setState({
                docMaster: this.props.docMasterList,
                isDocumentFetched: true
            });
        }
        if(prevProps.companyDocStatus?.toJS().companyDocStatus != "FETCHED" &&this.props.companyDocStatus?.toJS().companyDocStatus === "FETCHED"){
            this.props.failedValidateDocument();
        }
      
        this.createRequestDocIdList();
    }
    handleScrollPosition = () => {
        const scrollPosition = sessionStorage.getItem("scrollPosition");
        const searchFilterVals = sessionStorage.getItem("searchFilterVals");
        const scrollPositionDocReview = sessionStorage.getItem("scrollPositionDocReview");
        if (scrollPositionDocReview) {
            document.getElementsByClassName("case-detail-row-scroll")[0]?.scrollTo({top:parseInt(scrollPosition), behavior: 
                "smooth" 
            });
            sessionStorage.removeItem("scrollPositionDocReview");
        }
        if (scrollPosition) {
            document.getElementsByClassName("doc-list-view-scroll")[0].scrollTo({top:parseInt(scrollPosition), behavior: 
            "smooth" 
            });
            sessionStorage.removeItem("scrollPosition");
        }
        if (searchFilterVals) {
            this.setState({searchFilterVals: searchFilterVals?.split(",")});
            sessionStorage.removeItem("searchFilterVals");
        }
    };

    createRequestDocIdList() {
        if(this.props.files&&this.props.files.size>0 && this.state.requestedDocs.length === 0) {
            const isAlreadyRequested =
            (this.props.files &&
                this.props.files
                    .filter(
                        _ =>
                            _.document_status ===
                            DOCUMENT_CURRENT_STATUS.get("Requested")
                    )
                    .map(_ => _.document&&_.document.id)
                    .toMap()
                    .mapEntries(([, v]) => [v,v])
                    .toList()
                    .toArray()) ||
                [];
            if(isAlreadyRequested.length) {
                // this.setState({
                //     requestedDocs: isAlreadyRequested
                // });
            }
        }
    }

    viewDoc = file => {
        const filePath = file.file;
        const fileNameArr = (file.file && file.file.split("/").reverse()[0].split(".")) || [];
        const fileType = fileNameArr.reverse()[0];

        this.setState(
            {
                selectedFileType: file.file_mime_type && file.file_mime_type !== "application/x-empty" ? file.file_mime_type : fileType,
                selectedFilePath: filePath,
                selectedFile: file,
                fileName: file.file_name
            },
            () => this.forceUpdate()
        );
    };

    updateDocument = (action, file, associate, address, bankAccount) => {
        switch (action) {
        case "APPROVE":
            this.props.validateDocument(
                this.props.companyId,
                null,
                file,
                associate,
                address,
                bankAccount,
                {validateFromCompany : true}
            );
            break;
        case "REJECT":
            this.props.invalidateDocument(
                this.props.companyId,
                null,
                file,
            );
            break;
        case "DELETE":
            this.props.invalidateDocument(
                this.props.companyId,
                null,
                file,
            );
            this.setState({
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null
            });
            break;
        default:
            break;
        }
        /*eslint-enable*/
    };

    deleteRequestedDocument = (docId, document) => {
        this.props.invalidateDocument(
            this.props.companyId,
            docId,
            document.merge({
                is_active: false
            }),
            ''
        );
        this.setState(
            {
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null
            });
    };

    addRequestedRemark = (docId, document) => {
        this.setState({
            selectedFile: document,
            showRequestedRemarks: true,
            requestedRemarks: document.request_remarks
        });
    };

    sendRequestToDocument = () => {
        this.props.addRequestRemarks(
            this.props.companyId,
            this.state.selectedFile.id,
            this.state.selectedFile.merge({
                request_remarks: this.state.requestedRemarks
            }),
            ''
        );
        this.setState(
            {
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null,
                requestedRemarks: null,
                showRequestedRemarks: false
            });
    }

    onKeyUp = e => {
        if (this.state.selectedFile) {
            const keyCode = e.keyCode;

            const currentFileIndex = this.props.files.findIndex(
                _ => _ && _.id === this.state.selectedFile.id
            );

            if (keyCode === 38) {
                if (currentFileIndex > 0) {
                    this.viewDoc(this.props.files
                        .filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested"))
                        .sort((a, b) => {
                            if(a.id > b.id) {
                                return -1;
                            }
                            if(a.id < b.id) {
                                return 1;
                            }
                            if(a.id === b.id) {
                                return 0;
                            }
                        })
                        .get(currentFileIndex - 1));
                }
            }
            if (keyCode === 40) {
                if (currentFileIndex < this.props.files.size - 1) {
                    this.viewDoc(this.props.files
                        .filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested"))
                        .sort((a, b) => {
                            if(a.id > b.id) {
                                return -1;
                            }
                            if(a.id < b.id) {
                                return 1;
                            }
                            if(a.id === b.id) {
                                return 0;
                            }
                        })
                        .get(currentFileIndex + 1));
                }
            }
        }
    };

    invalidateDoc = () => {
        this.props.invalidateDocument(
            this.props.companyId,
            this.state.selectedFile && this.state.selectedFile.id,
            this.state.selectedFile
                .set("remarks", this.state.remarks)
                .set("file_name", this.state.fileName),
            ''
        );
    };

    changeName = file => {
        this.props.validateDocument(
            this.props.companyId,
            null,
            file
        );
    };

    getDocumentType = () => {
        if (
            this.state.fileName &&
            this.state.fileName.toLowerCase().includes("adhar")
        ) {
            return "aadhaar";
        }
        if (
            this.state.fileName &&
            this.state.fileName.toLowerCase().includes("pan")
        ) {
            return "pan";
        }
        return null;
    };

    openRequestModal = () => {
        this.setState({
            requestModal: true
        });
    };

    closeRequestModal = () => {
        this.setState({
            requestModal: false,
            requestDocSearchQuery: null
        });
    };

    onChangeRequestDocs=(val) => {
        this.setState({
            requestedDocs: val
        });
    };

    requestDocumentsHandler=() => {
        let filteredApplicantDocs = this.state.requestedDocs.filter(_ => applicantDocuments[_]);
        let filteredAadharBoth = this.state.requestedDocs.filter(_ => applicantAadharBoth[_]);
        let filterOtherDocuments = this.state.requestedDocs.filter(_ => otherDocuments[_])
        if(filteredApplicantDocs.length > 0 || filteredAadharBoth.length > 0){
            this.setState({
                applicantSelectModal : true,
                requestedApplicantDocs : filteredApplicantDocs,
                filteredAadharBoth : filteredAadharBoth,
                filterOtherDocuments : filterOtherDocuments,
            });
        }else if(filterOtherDocuments.length > 0){
            this.setState({
                filterOtherDocuments : filterOtherDocuments,
                applicantSelectModal : true,
            })
        } else{
            const newDocs=Object.assign([],this.state.requestedDocs);
            this.setState(
                {
                    requestModal: false,
                    requestedDocs: []
                },
                () => {
                    this.props.requestDocuments(
                        '',
                        this.props.companyId,
                        newDocs
                    );
                }
            );
        } 
    };

    parseDocument = (file, docType) => {
        this.props.parseDocument(
            file,
            docType.toLowerCase()
        );
    };



    requestDocSearch=event => {
        this.setState({
            requestDocSearchQuery: event.target.value
        });
    }

    filterDocumentCategory = (doc) => {
        return this.state.requestDocSearchQuery? doc.document_name && doc.document_name.toLocaleLowerCase().includes(this.state.requestDocSearchQuery.toLocaleLowerCase()):true;
    }

    createNewDocument = (blob) => {
        let newBlob = blob;
        const file = new File([newBlob], this.state.selectedFile.file_name, {type: blob.type, lastModified: new Date()});
        const formData = new FormData();
        formData.append("file", file);
        formData.append("company", this.props.companyId);
        formData.append("file_name", this.state.selectedFile.file_name);
        formData.append("parent_document_master", this.state.selectedFile.id);
        formData.append("file_mime", blob.type);
        this.props.uploadDocument('', this.props.companyId, formData);
        this.updateDocument("DELETE", this.state.selectedFile.set("is_active", false), null, null);
    }

    closeRequestRemarksModal = () => {
        this.setState({
            showRequestedRemarks: false,
            requestedRemarks: null 
        });
    }
    scrollPositionFunc = (val, searchFilterArr) => {
        scrollPositionValue = val;
        this.setState({searchFilterVals:searchFilterArr});
    }
    handleApplicantSelectModal=() => {
        this.setState({
            document : [],
            requestedDocs : [],
            requestedApplicantDocs  : [],
            filteredAadharBoth : [],
            filterOtherDocuments : [],
            applicantSelectModal : !this.state.applicantSelectModal
        });
    }

    onSelectApplicantForRequestedDoc = (docId, associate , docRemarks = '') => {
        let alreadyAdded = this.state.document.find(_ => _.id == docId);
        if(alreadyAdded && alreadyAdded.id){
            this.setState({
                document : this.state.document.filter(_ => _.id != docId)} , () => {
                this.setState({
                    document : [...this.state.document , {
                        id : docId,
                        associate : associate ? associate : undefined,
                        request_remarks : docRemarks ? docRemarks : undefined
                    }]
                });
            });
        }else{
            this.setState({
                document : [...this.state.document , {
                    id : docId,
                    associate : associate ? associate : undefined,
                    request_remarks : docRemarks ? docRemarks : undefined
                }]
            });
        }
    }

    requestApplicantDocumentsHandler = () => {
        const allRequestedDocs = [...this.state.requestedDocs];
        let documents_associate = this.state.document.map(_ => {
            if(_.id.toString().includes("-")){
                _.document_option_id =  parseInt(_.id.split("-")[1]);
                _.id = parseInt(_.id.split("-")[0]);
            }else{
                _;
            }
            return _;
        });
        this.handleApplicantSelectModal();
        this.setState({
            requestModal : false,
            requestedApplicantDocs : [],
        } , () => {
            let data = {
                document : documents_associate,
                documents : allRequestedDocs.filter(_ => !applicantDocuments[_] && !applicantAadharBoth[_] && !otherDocuments[_])
            };
            this.props.requestDocuments(
                '',
                this.props.companyId,
                data,
                true
            );
            this.setState({
                document : [],
                requestedDocs : [],
            });
        });
    }

    selectApplicantModal = () => {
        const {requestedApplicantDocs , filteredAadharBoth , filterOtherDocuments} = this.state;
        const filteredRequestRemarks = this.state.document.filter(_ => _.request_remarks != null && _.request_remarks != "")
        return <Modal
            visible={this.state.applicantSelectModal}
            onCancel={this.handleApplicantSelectModal}
            title={"Select Applicant/Document Name"}
            onOk={this.requestApplicantDocumentsHandler}
            className={"doc-checkboxes"}
            width={"40vw"}
            height={"80vh"}
            okButtonProps={{ disabled: filteredRequestRemarks.some(_ => _.request_remarks.length < 5 ) }}
            bodyStyle={{
                maxHeight: "500px",
                overflowY: "scroll"
            }}>
            {requestedApplicantDocs.map((_ , key) => <Col key={key} span={24} style={{
                paddingTop: "2px",
                paddingBottom: "2px"
            }} className={"d-flex justify-content-space-between"}>
                <p>{applicantDocuments[_]}</p>
                <Select
                    className={"fb-50"}
                    style={{
                        minWidth: "200px"
                    }}
                    size={"small"}
                    dropdownMatchSelectWidth={false}
                    onChange={(val) => this.onSelectApplicantForRequestedDoc(_ , val , '')}
                >
                    {this.props.associates.map((_, k) => (
                        <Select.Option key={k} value={_ && _.id}>
                            {`${_ && _.first_name} ${_ && _.last_name}`}
                        </Select.Option> 
                    )).toList()}
                </Select>
            </Col>)}
            {filteredAadharBoth.map((_ , key) => <Col key={key} span={24} style={{
                paddingTop: "2px",
                paddingBottom: "2px"
            }} className={"d-flex justify-content-space-between"}>
                <p>{applicantAadharBoth[_]}</p>
                <Select
                    className={"fb-50"}
                    style={{
                        minWidth: "200px"
                    }}
                    size={"small"}
                    dropdownMatchSelectWidth={false}
                    onChange={(val) => this.onSelectApplicantForRequestedDoc(_ , val , '')}
                >
                    {this.props.associates.map((_, k) => (
                        <Select.Option key={k} value={_ && _.id}>
                            {`${_ && _.first_name} ${_ && _.last_name}`}
                        </Select.Option> 
                    )).toList()}
                </Select>
            </Col>)}
            {filterOtherDocuments.map((_ , key) => <Col key={key} span={24} style={{
                paddingTop: "2px",
                paddingBottom: "2px"
            }} className={"d-flex justify-content-space-between"}>
                <p>{otherDocuments[_]}</p>
                <FormItem help={filteredRequestRemarks.some(_ => _.request_remarks.length < 5 ) ? "Minimum Characters should be 5" : ""}>
                    <TextArea 
                        rows={2}
                        placeholder="Enter document name"
                        onChange={(e) =>this.onSelectApplicantForRequestedDoc(_ , '', e.target.value)}
                        className={"fb-50"}
                        minLength={5}
                        style={{
                            minWidth: "200px"
                        }}/>
                </FormItem>
            </Col>)}
        </Modal>;
    }

    render() {
        this.groupedDocMasterList =
            this.props.docMasterList &&
            this.props.docMasterList.length &&
            new List(this.props.docMasterList).groupBy(
                item => item.document_category && item.document_category.name
            ).map(_ => _.filter(this.filterDocumentCategory))
                .filter(_ => _.size > 0);


        return (
            <React.Fragment>
                {this.selectApplicantModal()}
                
                <Modal
                    visible={this.state.requestModal}
                    onCancel={this.closeRequestModal}
                    title={"Request Documents"}
                    destroyOnClose
                    onOk={this.requestDocumentsHandler}
                    className={"doc-checkboxes"}
                    width={"40vw"}
                    height={"80vh"}
                    bodyStyle={{
                        maxHeight: "500px",
                        overflowY: "scroll"
                    }}>
                    <Input.Search onChange={this.requestDocSearch} placeholder={"Type Document Name to search"} />
                    <Checkbox.Group
                        style={{
                            width: "100%"
                        }}
                        onChange={this.onChangeRequestDocs}
                    >
                        {this.groupedDocMasterList &&
                        this.groupedDocMasterList.size ?
                            this.groupedDocMasterList.filter((obj , k) => k !=  'Progcap Others')
                                .map((_, k) => (
                                    <React.Fragment key={`${k}-item`}>
                                        <Divider
                                            orientation={"left"}
                                            key={`${k}-divider`}>
                                            {" "}
                                            {k}{" "}
                                        </Divider>
                                        <Row>
                                            {_
                                                .map(__ => (
                                                    <Col span={12} key={__.id}>
                                                        {__.document_document_type_option.length > 0 ? __.document_document_type_option.map(docOption =>  <Checkbox
                                                            className={"fb-50"}
                                                            key={docOption.id}
                                                            value={`${__.id}-${docOption.id}`}>
                                                            {docOption.document_type_name}
                                                        </Checkbox>): <Checkbox
                                                            className={"fb-50"}
                                                            key={__.id}
                                                            value={__.id}>
                                                            {__.document_name}
                                                        </Checkbox>}
                                                        
                                                    </Col>
                                                ))}
                                        </Row>

                                    </React.Fragment>
                                ))
                                .toList()
                                .toArray():null}
                    </Checkbox.Group>
                </Modal>
                <Modal
                    visible={this.state.showRequestedRemarks}
                    title={"Add Request Remarks"}
                    destroyOnClose
                    onOk={this.sendRequestToDocument}
                    onCancel={this.closeRequestRemarksModal}
                >
                    <Input.TextArea onChange={(e) => {
                        this.setState({
                            requestedRemarks: e.target.value
                        });
                    }} value={this.state.requestedRemarks} />
                </Modal>
            
                <div tabIndex={0} onKeyDown={this.onKeyUp}>
                    <Layout className={"doc-review-layout"}>
                        <Layout.Content>
                            <Row
                                className={
                                    "d-flex h-100 p-5 base-layout-row"
                                }>
                                <Col
                                    span={7}
                                    className={"doc-list p-5"}>

                                    <DocumentViewList
                                        associates={
                                            this.props.associates
                                        }
                                        caseId={this.props.caseId}
                                        files={this.props.files}
                                        viewDoc={this.viewDoc}
                                        selectedFileId={
                                            this.state.selectedFile &&
                                            this.state.selectedFile.id
                                        }
                                        stageId={this.props.stageId}
                                        addRequestedRemark={this.addRequestedRemark}
                                        companyId={this.props.companyId}
                                        uploadFiles={this.props.uploadDocuments.bind(
                                            null,
                                            '',
                                            this.props.companyId
                                        )}
                                        filesStatus={
                                            this.props.filesStatus
                                        }
                                        scrollPositionProp={this.scrollPositionFunc}
                                        searchFilterVals={this.state.searchFilterVals}
                                        changeName={this.changeName}
                                        openRequestModal={
                                            this.openRequestModal
                                        }
                                        noDocumentDeletePerm={this.props.noDocumentDeletePerm}
                                        categoryList={
                                            (this.props.docMasterList && new List(this.props.docMasterList)
                                                .toMap()
                                                .mapEntries(
                                                    ([,v]) => [v.document_name, v.document_name]
                                                )
                                                .toList().toArray())
                                                || []
                                        }
                                        docMasterListStatus={
                                            this.props
                                                .docMasterListStatus
                                        }
                                        deleteRequestedDocument={
                                            this.deleteRequestedDocument
                                        }
                                        fetchFiles={this.handleFilesFetch.bind(this , true)}
                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    />
                                </Col>
                                <Col span={17}>
                                    <SignzyDataForm
                                        fileType={
                                            this.state.selectedFileType
                                        }
                                        filePath={
                                            this.state.selectedFilePath
                                        }
                                        file={this.props.files.find(_ => _.id === (this.state.selectedFile && this.state.selectedFile.id))}
                                        documentType={this.getDocumentType()}
                                        associates={
                                            this.props.associates
                                        }
                                        bankAccounts={this.props.bankAccounts}
                                        docMasterList={
                                            this.state.docMaster
                                        }
                                        companyId={this.props.companyId}
                                        updateDocument={
                                            this.updateDocument
                                        }
                                        addressesList={
                                            this.props.addressesList
                                        }
                                        parseData={this.parseDocument}
                                        createNewDocument={this.createNewDocument}
                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    />
                                </Col>
                            </Row>
                        </Layout.Content>
                    </Layout>
                </div>
            </React.Fragment>
        );
    }
}

CompanyDocumentReviewTab.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    files: PropTypes.object,
    filesStatus: PropTypes.string,
    fetchCompanyDocuments: PropTypes.func,
    uploadDocuments: PropTypes.func,
    updateDocument: PropTypes.func,
    fetchDocumentTypes: PropTypes.func,
    fetchApplicantsList: PropTypes.func,
    associatesStatus: PropTypes.string,
    associates: PropTypes.array,
    bankAccounts: PropTypes.array,
    docMasterListStatus: PropTypes.string,
    docMasterList: PropTypes.array,
    companyDocStatus: PropTypes.string,
    validateDocument: PropTypes.func,
    invalidateDocument: PropTypes.func,
    updateCompanySingleAssociate: PropTypes.func,
    requestDocuments: PropTypes.func,
    addressesList: PropTypes.object,
    failedValidateDocument: PropTypes.func,
    failedInvalidateDocumentStatus: PropTypes.func,
    attachDocument: PropTypes.func,
    parseDocument: PropTypes.func,
    panParsedData: PropTypes.object,
    aadhaarParsedData: PropTypes.object,
    sendRequest: PropTypes.func,
    uploadDocument: PropTypes.func,
    addRequestRemarks: PropTypes.func,
    stageId: PropTypes.number,
    noDocumentDeletePerm: PropTypes.bool,
    fetchCaseDetail: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
	return ({
		uploads: state.documents.getIn(["uploads", props.companyId]),
		docMasterListStatus: state.documents.getIn([
			"documentsMasterList",
			"status"
		]),
		companyDocStatus:state.documents.getIn(["company_documents"]),
		docMasterList: state.documents.getIn(["documentsMasterList", "data"]),
		associates: state.documents.getIn(['allAssociates' , props.companyId], Map({})),
		associatesStatus: state.documents.getIn([
			props.companyId,
			"status",
			"associatesStatus"
		], STATE_STATUS.UNFETCHED),
		addressesList: state.companyLosProfiles.getIn([
			'profiles',
			props.companyId,
			"data",
			"addresses"
		]),
		bankAccounts: state.companies.getIn([
			props.companyId,
			"data",
			"bank_accounts"
		]),
		files: state.documents
			.getIn(["company_documents", props.companyId, "data"], Map({}))
			.map(_ => _.get("data"))
			.filter(_ => _.is_active)
			.sort((a, b) => (a.modified_date.isBefore(b.modified_date) ? 1 : -1))
			.toList(),
		filesStatus: state.documents.getIn(
			["company_documents", props.companyId, "status"],
			STATE_STATUS.UNFETCHED
		),
		panParsedData: state.documents.getIn([
			"parsedData",
			props.companyId,
			"pan"
		]),
		aadhaarParsedData: state.documents.getIn([
			"parsedData",
			props.companyId,
			"aadhaar"
		]),
		noDocumentDeletePerm: state.user.getIn(["permissions", "cannot_delete_document"]),
		stage: state.stages
			.get("data")
			.find(_ => _.id === props.stageId),
		company:
		props.companyId
			? state.companies.getIn([props.companyId, "data"])
			: null,
	
	})
    };

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCompanyDocuments,
            updateDocument,
            uploadDocuments,
            fetchDocumentTypes,
            fetchApplicantsList,
            invalidateDocument,
            validateDocument,
            requestDocuments,
            attachDocument,
            parseDocument,
            sendRequest,
            uploadDocument,
            failedValidateDocument,
            failedInvalidateDocumentStatus,
            fetchCaseDetail,
            addRequestRemarks
        },
        dispatch
    );

const WrappedComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyDocumentReviewTab);
export default PermissionContextManager({
    permission: UI_PERMISSIONS.DOCUMENTS_VIEW,
    propsPermissions: {
        DOCUMENTS_EDIT: UI_PERMISSIONS.DOCUMENTS_EDIT
    }
})(WrappedComponent);
